import CTALink from "@/components/CTA/ctaLink";
import LocalizedOfferEndsPrefix from "@/components/PromoBanner/components/LocalizedOfferEndsPrefix";
import PromoBannerTooltip from "@/components/PromoBanner/components/PromoBannerTooltip";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";
import boldTextWithAsterisk from "@/utils/functions/boldTextWithAsterisk";

export default function PromoBannerCardSplit({
  className,
  cta,
  ctaElement,
  description,
  discount,
  discountCode,
  endDatePrefix,
  endDate,
  learnMoreLink,
  title,
  useDefaultDiscountText = true,
  tooltip,
}: BasePromoBannerProps) {
  return (
    <div className={`flex flex-col gap-4 mx-auto w-full ${className || ""}`}>
      <div className="bg-secondary rounded-xl p-6 w-full">
        <h2 className="text-2xl text-secondary-foreground italic m-0">
          {title}
        </h2>
      </div>
      <div className="bg-primary rounded-xl p-6 w-full grow">
        <p className="text-md text-primary-foreground mb-4">
          {typeof description === "string"
            ? boldTextWithAsterisk(description)
            : description}{" "}
          {useDefaultDiscountText && !!discount && !!discountCode && (
            <span>
              Get <strong>up to {discount} off</strong> on select courses with
              code <strong>{discountCode}</strong>.
            </span>
          )}
        </p>
        {ctaElement && <div className="mb-4">{ctaElement}</div>}
        {cta && !ctaElement && (
          <CTALink
            type="brand"
            size="sm"
            className="mb-4 py-1"
            label={cta.label}
            url={cta.url}
            location={cta.location}
            html_id={cta.html_id}
          />
        )}
        <div className="flex gap-1 items-center">
          <p className="text-sm text-primary-foreground mb-0">
            <LocalizedOfferEndsPrefix prefix={endDatePrefix} date={endDate} />.
          </p>
          <PromoBannerTooltip
            discountCode={discountCode}
            endDate={endDate}
            learnMoreLink={learnMoreLink}
            htmlContent={tooltip?.infoText ?? ""}
            size={16}
          />
        </div>
      </div>
    </div>
  );
}
